import { render } from "./rental-table.vue?vue&type=template&id=6dc203bb"
import script from "./rental-table.vue?vue&type=script&lang=js"
export * from "./rental-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__